// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__heb8g","loaderOuter":"PageOverlayLoader_loaderOuter__HkKn9"};